function quantizeCoord(n) {
  if (!Number.isFinite(n)) return 'n';
  return String(Math.round(n * 2) / 2);
}

export function pickMapForIds(map, ids) {
  if (!map || !ids || ids.size === 0) return {};
  const next = {};
  ids.forEach((id) => {
    if (map[id] != null) next[id] = map[id];
  });
  return next;
}

/**
 * Fingerprint everything that affects ELK node geometry and edge routing for this campaign.
 * When unchanged (e.g. second Tidy click with no edits), we can skip the ELK worker.
 */
export function makeElkLayoutInputFingerprint(
  layoutTasks,
  nodeDimensions,
  customPositions,
  lockedTaskIdSignature,
  lockedDependencySignature,
  chainOrderKey,
) {
  const taskPos = (layoutTasks || [])
    .map((t) => `${t.id}:${quantizeCoord(t.x)}:${quantizeCoord(t.y)}`)
    .sort()
    .join(',');
  const custom =
    customPositions && Object.keys(customPositions).length > 0
      ? Object.keys(customPositions)
          .sort()
          .map((id) => {
            const c = customPositions[id];
            return `${id}:${quantizeCoord(c?.x)}:${quantizeCoord(c?.y)}`;
          })
          .join(',')
      : '';
  const dims = Object.entries(nodeDimensions || {})
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([id, d]) => `${id}:${Math.round(d?.width ?? 0)}:${Math.round(d?.height ?? 0)}`)
    .join('|');
  return [
    lockedTaskIdSignature,
    lockedDependencySignature,
    chainOrderKey || '',
    dims,
    taskPos,
    custom,
  ].join('::');
}

export function clonePlainElkResult(r) {
  if (!r) return null;
  return {
    positions: { ...(r.positions || {}) },
    edgePaths: { ...(r.edgePaths || {}) },
    chainInfo: Array.isArray(r.chainInfo) ? [...r.chainInfo] : [],
  };
}

/** Reuse cached ELK output without deep-cloning large maps (redundant Tidy). */
export function shallowShellFromCachedElk(cached) {
  if (!cached) return null;
  return {
    positions: cached.positions,
    edgePaths: cached.edgePaths,
    chainInfo: cached.chainInfo,
  };
}

export function clearElkLayoutCache(fingerprintRef, resultRef) {
  fingerprintRef.current = null;
  resultRef.current = null;
}
